__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = undefined;
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fmcc-web-platform/platform-experience-lib", "3.27.0", () => (() => (__webpack_require__(3475))), 1);
			register("@module-federation/utilities", "3.1.67", () => (() => (__webpack_require__(400))), 1);
			register("@reduxjs/toolkit", "2.2.7", () => (() => (__webpack_require__(9425))), 1);
			register("react-dom/client", "18.2.0", () => (() => (__webpack_require__(7470))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(8325))), 1);
			register("react/jsx-runtime", "18.2.0", () => (() => (__webpack_require__(2540))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(3696))), 1);
			register("single-spa-layout", "2.2.0", () => (() => (__webpack_require__(4337))), 1);
			register("single-spa", "6.0.3", () => (() => (__webpack_require__(9513))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};